import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useGlobalContext } from '../../contexts';
import FrequencyCalculator from './FrequencyCalculator';

import { useSettings } from '@backpackjs/storefront';

export function FrequencyCalculatorCTA({
  linkedProductGroups,
  product,
  sectionSettings,
  selectedSellingPlan,
  selectedVariant,
  setSelectedSellingPlanByID,
}) {
  const {
    actions: { openDrawer },
  } = useGlobalContext();

  const [linkedProductHandles, setLinkedProductHandles] = useState([]);

  useEffect(() => {
    if (!linkedProductGroups) {
      return;
    }

    const linkedHandles = linkedProductGroups.flatMap((group) =>
      group.linkedProducts.map((item) => item.linkedProduct.handle)
    );

    setLinkedProductHandles(linkedHandles);
  }, [linkedProductGroups]);

  const settings = useSettings();
  const { ctaToOpenCalculator } = settings?.filterReplacementCalculator;

  const handleFrequencyCalculatorModal = () => {
    openDrawer(
      <FrequencyCalculator
        linkedProductHandles={linkedProductHandles}
        product={product}
        sectionSettings={sectionSettings}
        selectedSellingPlan={selectedSellingPlan}
        selectedVariant={selectedVariant}
        setSelectedSellingPlanByID={setSelectedSellingPlanByID}
        subscriptionProducts={settings?.subscriptions?.subscriptionProducts}
      />,
      {className: 'frequency-calculator-modal-drawer'}
    );
  };

  return (
    <div className="pdp-frequency-calculator-simplified mb-1 text-center md:mb-4">
      <button
        type="button"
        onClick={() => {
          handleFrequencyCalculatorModal();
        }}
        className="cursor-pointer text-[13px] text-textLink underline md:text-base"
      >
        {ctaToOpenCalculator}
      </button>
    </div>
  );
}

FrequencyCalculatorCTA.propTypes = {
  frequencyCalculatorSettings: PropTypes.shape({
    content: PropTypes.string,
    cta: PropTypes.string,
    enableFrequencyCalculator: PropTypes.bool,
    product: PropTypes.object,
    recommendationImage: PropTypes.object,
    recommendationName: PropTypes.string,
    responseMap: PropTypes.array,
    selectedSellingPlan: PropTypes.object,
    selectedVariant: PropTypes.object,
    title: PropTypes.string,
    setSelectedSellingPlanByID: PropTypes.func,
    linkedProductGroups: PropTypes.object,
  }),
};
